<script setup lang="ts">
import Page from "@/components/page/Page.vue";
</script>

<template>
    <page>
        <section>
            <h3>Uitleg</h3>
            <p>xxx</p>
        </section>
    </page>
</template>
